// Timestamp utilities for JS↔PostgreSQL conversion
const ISO = (ts) => new Date(ts).toISOString();
const FROM_ISO = (str) => new Date(str).getTime();

export function jsTimestampToPostgres(jsTimestamp) {
  return (!jsTimestamp || typeof jsTimestamp !== 'number') ? ISO(Date.now()) : ISO(jsTimestamp);
}

export function postgresTimestampToJs(pgTimestamp) {
  return !pgTimestamp ? Date.now() : FROM_ISO(pgTimestamp);
}

export function getCurrentTimestamps() {
  const now = Date.now();
  return { js: now, postgres: ISO(now), iso: ISO(now) };
}

export function normalizeTimestamp(timestamp) {
  let jsTimestamp;
  
  if (typeof timestamp === 'number') jsTimestamp = timestamp;
  else if (typeof timestamp === 'string') jsTimestamp = FROM_ISO(timestamp);
  else if (timestamp instanceof Date) jsTimestamp = timestamp.getTime();
  else jsTimestamp = Date.now();
  
  return { js: jsTimestamp, postgres: ISO(jsTimestamp), iso: ISO(jsTimestamp) };
}

export function sortMessagesByTimestamp(messages) {
  if (!Array.isArray(messages)) return [];
  
  const getTs = (msg) => {
    const ts = msg.createdAt || msg.timestamp || msg.created_at || 0;
    return typeof ts === 'string' ? FROM_ISO(ts) : ts;
  };
  
  return [...messages].sort((a, b) => getTs(a) - getTs(b));
}

export function findLatestMessage(messages) {
  if (!Array.isArray(messages) || messages.length === 0) return null;
  const sorted = sortMessagesByTimestamp(messages);
  return sorted[sorted.length - 1];
}

export function createTimestampBasedMessageId(timestamps = null, prefix = 'msg') {
  const ts = timestamps || getCurrentTimestamps();
  return `${prefix}_${ts.js}_${Math.random().toString(36).substr(2, 6)}`;
}

export function extractTimestampFromMessageId(messageId) {
  if (!messageId || typeof messageId !== 'string') return null;
  const match = messageId.match(/^[^_]+_(\d+)_/);
  return match && match[1] ? parseInt(match[1], 10) : null;
}
